'use client';

import {
  NavigationDrawerItem,
  NavigationDrawerRow,
  NavigationDrawerRowFigure,
  NavigationDrawerRowLabel,
  NavigationDrawerRowMain,
} from '@vs-shop/commerce-ui/navigationDrawer';
import { Gift } from 'lucide-react';

import type { NavigationSpecialEventsLinkT } from '../../../../data/navigationSpecialEventsLinks';

import { navigateFullPage } from '../../../../utils/router';

type Props = {
  link: NavigationSpecialEventsLinkT;
  onClickAction: () => void;
};

export default function MobileNavigationSpecialEventsLink({ link, onClickAction }: Props) {
  const { href, title } = link;

  const handleClick = () => {
    onClickAction();
    navigateFullPage(href);
  };

  return (
    <NavigationDrawerItem>
      <NavigationDrawerRow variant="warning" onClick={handleClick}>
        <NavigationDrawerRowMain>
          <NavigationDrawerRowFigure variant="warning">
            {/* HARDCODED GIFT ICON FOR ALL SPECIAL EVENTS LINKS */}
            <Gift className="size-5 shrink-0" />
          </NavigationDrawerRowFigure>
          <NavigationDrawerRowLabel>{title}</NavigationDrawerRowLabel>
        </NavigationDrawerRowMain>
      </NavigationDrawerRow>
    </NavigationDrawerItem>
  );
}
